<template>
    <el-dialog
        width="500px"
        title="请输入修改后的采购mis号"
        :visible.sync="visible"
        append-to-body
        :close-on-click-modal="false"
        class="edit-dialog"
    >
        <div class="mb20">
            修改后原采购将无法看到该新品审核，请谨慎修改
        </div>
        <el-input
            v-model.trim="misId"
            placeholder="请输入mis号"
        />
        <span
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                type="primary"
                @click="onSave"
            >确认</el-button>
            <el-button @click="onClose">取消</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: 'EditMisDialog',
    components: {
    },
    props: {
        applyId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            visible: false,
            misId: '',
        };
    },
    methods: {
        async onSave() {
            if (!this.misId) {
                this.$message.error('mis号不能为空');
                return;
            }
            const res = await this.$hPost('/api/vss/shepherd/product/bizcenter/VssNewSaleCommandTService/updateEditorAndClearClaim', {
                applyId: this.applyId,
                newEditor: this.misId,
            }).catch(() => 'error');
            if (res === 'error') return;
            this.$message.success('修改成功');
            this.$emit('success', {
                misId: this.misId,
                version: res.version,
            });
            this.visible = false;
        },
        onClose() {
            this.$emit('cancel');
            this.reset();
            this.visible = false;
        },
        reset() {
            this.misId = '';
        },
        async _popup() {
            this.visible = true;
        },
    },
};
</script>
